module.exports = __webpack_public_path__ + "static/media/IN-SALUD.c500ca6c.jpg";